import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./Authprovider";

const PROFILE_COMPLETION_THRESHOLD = 80;

/**
 * For /chat route: sellers can access when profile completion is at least 80%.
 * Buyers and others are not restricted.
 */
export const SellerChatGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { userRole, profileCompletionPercentage, profileCompleteWithoutSocial, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  const profileCompleteEnough =
    (typeof profileCompletionPercentage === "number" && profileCompletionPercentage >= PROFILE_COMPLETION_THRESHOLD) ||
    profileCompleteWithoutSocial === true;
  if (userRole === "seller" && !profileCompleteEnough) {
    return <Navigate to="/seller/profile_settings" replace />;
  }

  return <>{children}</>;
};
